import { z } from "zod";
import { isSafeUrl } from "@profolio/security";

/**
 * Validates that a string is a properly formatted URL and uses a safe protocol.
 * Safe protocols include: http:, https:, mailto:, tel:
 */
export const safeUrlSchema = z.string().max(1024, "URL too long").url("Invalid URL format").refine(
  (val) => isSafeUrl(val, ["http:", "https:", "mailto:", "tel:"]),
  { message: "Unsafe or unsupported URL protocol" }
);

/**
 * Validates that a string is a properly formatted URL and uses strictly HTTP or HTTPS.
 * Use this for web links, images, files, and project URLs.
 */
export const safeHttpUrlSchema = z.string().max(1024, "URL too long").url("Invalid URL format").refine(
  (val) => isSafeUrl(val, ["http:", "https:"]),
  { message: "URL protocol must be http or https" }
);
